/**
 * Creates a new DrlCtScannerContrastReportController.
 * @class
 */
class DrlCtScannerContrastReportController {
    constructor($ngRedux, $state, NavigationService, DoseReferenceLevelsActions, Notifier, $filter) {
        this.$ngRedux = $ngRedux;
        this.$state = $state;
        this.NavigationService = NavigationService;
        this.DoseReferenceLevelsActions = DoseReferenceLevelsActions;
        this.Notifier = Notifier;
        this.filter = $filter;
    }

    $onInit() {
        const navConfig = this.NavigationService.getConfig(this.$state.$current);
        this.colorName = navConfig.colorName;
        this.title = this.filter('translate')('DLR.CT_SCANNER.CONTRAST_REPORT.GRID_DESC');

        this.unsubscribe = this.$ngRedux.connect(this.mapState, this.DoseReferenceLevelsActions)(this);
    }

    download() {
        if (this.contrastReportForm.$valid) {
            this.Notifier.info(this.filter('translate')('DLR.CT_SCANNER.CONTRAST_REPORT.NOTIFIER_WAIT'), false);
            this.generateContrastReport(this.contrast, this.dateFrom, this.dateTo, this.location).then(() => {
                this.contrastReportForm.$setPristine();
                this.contrastReportForm.$setUntouched();
            }, error => {
                this.Notifier.responseMessage(error);
            });
        }
        else this.Notifier.error(this.filter('translate')('DLR.CT_SCANNER.CONTRAST_REPORT.NOTIFIER_ERROR'));
    }

    $onDestroy() {
        this.unsubscribe();
    }

    mapState(state) {
        return {
            contrast: state.doseReferenceLevels.drlCtScannerContrastReport.contrast,
            dateFrom: state.doseReferenceLevels.drlCtScannerContrastReport.dateFrom,
            dateTo: state.doseReferenceLevels.drlCtScannerContrastReport.dateTo,
            location: state.doseReferenceLevels.drlCtScannerContrastReport.location
        }
    }
}

DrlCtScannerContrastReportController.$inject = ['$ngRedux', '$state', 'NavigationService', 'DoseReferenceLevelsActions', 'Notifier', '$filter'];

export const drlCtScannerContrastReport = {
    controller: DrlCtScannerContrastReportController,
    template: require('./drl-ct-scanner-contrast-report.html')
};
